import React, { useEffect } from 'react';
import { Button, Tooltip } from '@mui/material';
import { Feature } from '@loyalty/shared-common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormProvider, useForm } from 'react-hook-form';
import { QlfTitle } from '@qualifio/ui-commons';
import {
  ReferralConfigInput,
  referralConfigSchema,
} from '@loyalty/shared-common/gamification-api-client';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';
import { useTranslation } from 'react-i18next';
import { DetailForm } from '../../libs/shared/layout/DetailForm';
import { QlfMasterDetailContainer } from '../../libs/shared/layout/QlfMasterDetailContainer';
import { ReferralConfigForm } from '../../libs/referral/components/detail/ReferralConfigForm';
import { useFeatures } from '../../libs/features/FeaturesContext';
import { useJoiResolver } from '../../libs/shared/forms/use-joi-resolver';
import { useProgram } from '../../libs/loyalty/ProgramContext';
import { useReferralConfig } from '../../libs/referral/ReferralConfigContext';

export function ReferralPage() {
  const { program } = useProgram();
  const { t } = useTranslation();
  const { referralConfig, upsertReferralConfig } = useReferralConfig();
  const { features } = useFeatures();
  const { write: referralWrite } = features[Feature.REFERRAL];

  const form = useForm<ReferralConfigInput>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: referralConfig || { link: '' },
    resolver: useJoiResolver(referralConfigSchema),
  });

  const { isDirty, isSubmitting } = form.formState;

  const onSubmit = (referralConfigValue: ReferralConfigInput) => {
    upsertReferralConfig(referralConfigValue).catch(console.error);
  };

  useEffect(() => {
    form.reset(referralConfig);
  }, [form, referralConfig, program]);

  return (
    <QlfMasterDetailContainer>
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit, console.error)} style={{ height: '100%' }}>
          <DetailForm>
            <DetailForm.Form>
              <QlfTitle variant="h2" separator={{ state: 'left' }}>
                {t('referral.edition.title')}
              </QlfTitle>
              <ReferralConfigForm />
            </DetailForm.Form>
            <DetailForm.Footer>
              <Tooltip
                title={referralWrite ? '' : t('shared.action.permission.required')}
                placement="left"
              >
                <div>
                  <Button
                    type="submit"
                    startIcon={
                      <FontAwesomeIcon
                        type="submit"
                        fontSize="inherit"
                        icon={isSubmitting ? faSpinner : faCheck}
                        spin={isSubmitting}
                      />
                    }
                    color="success"
                    disabled={!isDirty || isSubmitting || !referralWrite}
                  >
                    {t('currencies.save.button')}
                  </Button>
                </div>
              </Tooltip>
            </DetailForm.Footer>
          </DetailForm>
        </form>
      </FormProvider>
    </QlfMasterDetailContainer>
  );
}
